import { HttpParams } from '@angular/common/http'
import { BaseWithId, PaginatedList, PaginatedSearchCriteria } from './base.model'

export class UserAccount extends BaseWithId {
    userName!: string
    firstName!: string
    lastName!: string
    email!: string
    accessFailedCounter?: number
    isLocked?: boolean
    lockoutendDate?: Date
    lastLoginDate?: Date
    identityRoles!: Array<string>
    employeeId!: number
    language!: string

    isSystemAccount?: boolean

    static fromJSON(json: any): UserAccount {
        const result: UserAccount = Object.create(UserAccount.prototype)

        return {
            ...result,
            ...json,
            lockoutendDate: json.lockoutendDate ? new Date(json.lockoutendDate) : null,
            lastLoginDate: json.lastLoginDate ? new Date(json.lastLoginDate) : null,
            isSystemAccount: json.email === 'infra@peopleware.be' || json.email === 'jira-importer@peopleware.be'
        }
    }
}

export class UserAccountSearchCriteria extends PaginatedSearchCriteria {
    userName?: string
    email?: string
    isLocked?: boolean

    constructor(page?: number, pageSize?: number, userName?: string, email?: string, isLocked?: boolean) {
        super(page, pageSize)
        this.userName = userName
        this.email = email
        this.isLocked = isLocked
    }

    httpParams(): HttpParams {
        let params = super.httpParams()

        if (this.userName !== undefined) {
            params = params.set('userName', this.userName)
        }
        if (this.email) {
            params = params.set('email', this.email)
        }
        if (this.isLocked) {
            params = params.set('isLocked', `${this.isLocked}`)
        }

        return params
    }
}

export class UserAccountPaginatedList extends PaginatedList<UserAccount> {
    static fromJSON(json: any): UserAccountPaginatedList {
        const result: UserAccountPaginatedList = Object.create(UserAccountPaginatedList.prototype)

        return {
            ...result,
            ...json,
            items: json.items ? json.items.map((item: any) => UserAccount.fromJSON(item)) : null
        }
    }
}
